import { decamelizeKeys } from 'humps';

import { Configs } from '~/features/admin/types';
import { pilot } from '~/services/serviceInstances';

type GetClientsParams = {
  configs: Configs;
};

export const createClient = async ({
  configs,
}: GetClientsParams): Promise<boolean> => {
  const params = decamelizeKeys(configs);

  return pilot.post('/client/', params);
};
